import { Component, Input, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-confirm-set-pw-dialog",
  templateUrl: "./confirm-set-pw-dialog.component.html",
  styleUrls: ["./confirm-set-pw-dialog.component.scss"]
})
export class ConfirmSetPwDialogComponent implements OnInit
{

  constructor(
    public dialogRef: MatDialogRef<ConfirmSetPwDialogComponent>
  ) { }

  ngOnInit(): void
  {
  }

}
